import { ccfRoutes } from '@app/ccf/ccf-routes';
import { Button } from '@shared/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';
import SupplyChainLogisticsPreviewSheet from './supply-chain-logistics-preview-sheet';
import { useCCF } from '@app/ccf/company-report/ccf-context';

export default function SupplyChainLogisticsTableToolbar() {
  const navigate = useNavigate();
  const { uuid: reportUuid } = useCCF();

  return (
    <div className="flex items-center gap-2">
      <SupplyChainLogisticsPreviewSheet />
      <Button
        size="sm"
        onClick={() =>
          navigate(
            generatePath(ccfRoutes.SUPPLY_CHAIN_LOGISTICS_FLOWS, {
              report_uuid: reportUuid,
            })
          )
        }
      >
        Add data
      </Button>
    </div>
  );
}
